// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","238":"userProfile-sampleRequests","464":"productSearch","518":"userProfile-notifications","751":"userProfile-productComparisons"}[chunkId] + ".3.7.0.css";
};